import { config } from '../config';
import axios from 'axios';
import { timeout } from '../helper';
import { useAuthStore } from '../../store/auth/useAuthStore';
import { removeCookie } from '../cookies';
import { useConfig } from '../../Hooks/useConfig';
import {
  showSuccessToast,
  showErrorToast,
  showWarningToast,
} from '../toast.jsx';

let api = {
  apiInfo: ({ name }) => {
    switch (name) {
      case 'register':
        return {
          method: 'POST',
          url: `/v1/users/register`,
          hasAuth: false,
          service: 'base',
          upload: false,
        };
      case 'login':
        return {
          method: 'POST',
          url: `/v1/users/login`,
          hasAuth: false,
          service: 'base',
          upload: false,
        };
      case 'loginProvider':
        return {
          method: 'GET',
          url: `/v1/users/oauth/{param}`,
          hasAuth: false,
          service: 'base',
          upload: false,
        };
      case 'accessTokenCallback':
        return {
          method: 'GET',
          url: `/v1/users/oauth/{param}`,
          hasAuth: false,
          service: 'base',
          upload: false,
        };
      case 'languages':
        return {
          method: 'GET',
          url: `/youtube-keywords/languages`,
          hasAuth: false,
          service: 'services',
          upload: false,
        };
      case 'countries':
        return {
          method: 'GET',
          url: `/youtube-keywords/countries`,
          hasAuth: false,
          service: 'services',
          upload: false,
        };
      case 'youtubeTitleTones':
        return {
          method: 'GET',
          url: `/youtube-title/tones`,
          hasAuth: false,
          service: 'services',
          upload: false,
        };
      case 'youtubeDescriptionTones':
        return {
          method: 'GET',
          url: `/youtube-description/tones`,
          hasAuth: false,
          service: 'services',
          upload: false,
        };
      case 'YoutubeKeyword':
        return {
          method: 'POST',
          url: `/youtube-keywords/`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'youtubeSuggestion':
        return {
          method: 'POST',
          url: `/youtube-suggestions/`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'youtubeTitle':
        return {
          method: 'POST',
          url: `/youtube-title/`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'youtubeDescription':
        return {
          method: 'POST',
          url: `/youtube-description/`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'youtubeHashtags':
        return {
          method: 'POST',
          url: `/youtube-hashtags/`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'youtubeSeo':
        return {
          method: 'POST',
          url: `/youtube-seo/`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'resumeScore':
        return {
          method: 'POST',
          url: `/resume-score/`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'resumeScoreFile':
        return {
          method: 'POST',
          url: `/resume-score/`,
          hasAuth: true,
          service: 'services',
          upload: true,
        };
      case 'resumeParser':
        return {
          method: 'POST',
          url: `/resume-parser/`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'resumeParserFile':
        return {
          method: 'POST',
          url: `/resume-parser/`,
          hasAuth: true,
          service: 'services',
          upload: true,
        };
      case 'resumeReview':
        return {
          method: 'POST',
          url: `/resume-review`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'resumeReviewFile':
        return {
          method: 'POST',
          url: `/resume-review`,
          hasAuth: true,
          service: 'services',
          upload: true,
        };
      case 'profileData':
        return {
          method: 'POST',
          url: `/profile-data`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'magicalResumeScore':
        return {
          method: 'POST',
          url: `/magical-resume-score`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'companyData':
        return {
          method: 'POST',
          url: `/company-data/`,
          hasAuth: true,
          service: 'services',
          upload: false,
        };
      case 'suggestSkill':
        return {
          method: 'POST',
          url: `/resume-parser/suggest-skills`,
          hasAuth: false,
          service: 'services',
          upload: false,
        };
      case 'getPlans':
        return {
          method: 'GET',
          url: `/payment/plans/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'getMoreCreditsPlans':
        return {
          method: 'GET',
          url: `/payment/plans/more-credits/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'getCoinList':
        return {
          method: 'GET',
          url: `/payment/coins/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'getInvoiceCrypto':
        return {
          method: 'POST',
          url: `/payment/invoices/pay/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'checkPayment':
        return {
          method: 'POST',
          url: `/payment/invoices/notify/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'activateTrial':
        return {
          method: 'POST',
          url: `/payment/activate-trial/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'userInfo':
        return {
          method: 'GET',
          url: `/v1/users/profile`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'resendEmail':
        return {
          method: 'POST',
          url: `/v1/users/verify-email`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'verifyEmailToken':
        return {
          method: 'PUT',
          url: `/v1/users/verify-email`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'isFirst':
        return {
          method: 'GET',
          url: `/v1/users/is-first`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'forgetPassword':
        return {
          method: 'POST',
          url: `/v1/users/forgot-password`,
          hasAuth: false,
          service: 'base',
          upload: false,
        };
      case 'resetPassword':
        return {
          method: 'POST',
          url: `/v1/users/reset-password`,
          hasAuth: false,
          service: 'base',
          upload: false,
        };
      case 'serviceList':
        return {
          method: 'GET',
          url: `/services-info/services/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'publicServiceList':
        return {
          method: 'GET',
          url: `/services-info/public-services/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'serviceInfo':
        return {
          method: 'GET',
          url: `/services-info/services/{param}/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'requestNumber':
        return {
          method: 'GET',
          url: `/services-info/report/{param}/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'subscribedService':
        return {
          method: 'POST',
          url: `/services-info/subscribe/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'unsubscribedService':
        return {
          method: 'POST',
          url: `/services-info/unsubscribe/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'getWhiteListDomainsList':
        return {
          method: 'GET',
          url: `/services-info/webhook/whitelist_domains/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'deleteWhiteListDomain':
        return {
          method: 'DELETE',
          url: `/services-info/webhook/whitelist_domains/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'addWhiteListDomain':
        return {
          method: 'POST',
          url: `/services-info/webhook/send_confirmation_request`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'submitStepperInfo':
        return {
          method: 'POST',
          url: `/v1/users/stepper`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'createApiKey':
        return {
          method: 'POST',
          url: `/v1/users/api-key`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'getApiKeys':
        return {
          method: 'GET',
          url: `/v1/users/api-key/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'deleteApiKey':
        return {
          method: 'DELETE',
          url: `/v1/users/api-key/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'addInvoice':
        return {
          method: 'POST',
          url: `/payment/invoices/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'historyData':
        return {
          method: 'GET',
          url: `/services-info/history/{param}/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'historyItem':
        return {
          method: 'GET',
          url: `/services-info/history/{param}/{param2}/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'exportData':
        return {
          method: 'GET',
          url: `/services-info/export/{param}/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'deletedHistoryData':
        return {
          method: 'DELETE',
          url: `/services-info/history/{param}/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'EditProfile':
        return {
          method: 'PUT',
          url: `/v1/users/edit-profile`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'deleteAccount':
        return {
          method: 'POST',
          url: `/v1/users/delete-account`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'endStepper':
        return {
          method: 'POST',
          url: `/v1/users/stepper`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'GetInvoice':
        return {
          method: 'GET',
          url: `/payment/invoices/{param}`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'GetInvoicePdf':
        return {
          method: 'GET',
          url: `/payment/invoices/payment-info/{param}`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'PaymentCancel':
        return {
          method: 'POST',
          url: `/payment/cancel-subscription`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'PaymentActivated':
        return {
          method: 'POST',
          url: `/payment/activate-subscription`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'ServicesUsage':
        return {
          method: 'GET',
          url: `/services-info/usage/{param}`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'CheckUpdateSubscription':
        return {
          method: 'GET',
          url: `/payment/check-updated/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'FaildCheckUpdateSubscription':
        return {
          method: 'POST',
          url: `/payment/check-updated/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'CreateManualInvoice':
        return {
          method: 'POST',
          url: `/payment/manual-invoices`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      case 'Examples':
        return {
          method: 'GET',
          url: `/services-info/call-playground/examples/{param}/`,
          hasAuth: true,
          service: 'base',
          upload: false,
        };
      default:
        throw new Error('Bad api name');
    }
  },

  request: async (
    name,
    data = {},
    params = {},
    headers = {},
    queryParam = '',
    queryParam2 = '',
    responseType = 'json',
    excel = false
  ) => {
    const shouldSkipSuccessToast = true;
    const shouldSkipErrorToast = false;

    // Get api info
    const apiInfo = api.apiInfo({ name });
    const { token, setToken } = useAuthStore.getState();
    const { baseDomain } = useConfig();
    axios.defaults.baseURL =
      apiInfo.service === 'base' ? config.baseUrl : config.servicesUrl;

    axios.defaults.headers.post['Content-Type'] = 'application/json';
    // Default headers
    const defaultHeaders = {
      'Content-Type': 'application/json',
    };
    defaultHeaders['authorization'] = `Bearer ${token}`;

    if (apiInfo.hasAuth) {
      const expires_Time = config.expires_in();
      if (Date.now() >= parseInt(expires_Time)) {
        removeCookie('token', baseDomain);
        localStorage.removeItem('expires_Time');
        localStorage.removeItem('finish_stepper');
        window.location.href = '/login';
        setToken('');
        // window.location.reload();
      }
    }
    if (apiInfo.upload === true) {
      let url = apiInfo.url
        .replace('{param}', queryParam)
        .replace('{param2}', queryParam2);
      const formData = new FormData();
      for (let i in data) {
        formData.append(i, data[i]);
      }
      defaultHeaders['content-Type'] = 'multipart/form-data';
      let response;
      try {
        response = await axios({
          url: apiInfo.url,
          method: apiInfo.method,
          data: formData,
          responseType: 'json',
          timeout: 180000,
          headers: {
            ...defaultHeaders,
            ...apiInfo.headers,
            ...headers,
          },
        });

        if (response.status === 201) {
          const { file, ...newData } = data;
          let request_id = response.data.data.request_id;
          var used_credit = response.data.usage.credits;
          response = await api.requestAgane(
            name,
            newData,
            params,
            headers,
            queryParam,
            queryParam2,
            responseType,
            excel,
            apiInfo,
            url,
            request_id,
            used_credit
          );
        }

        // SUCCESS TOAST HANDLING
        if (response.data.message && !shouldSkipSuccessToast) {
          showSuccessToast(response.data.message);
        }

        // ERROR TOAST HANDLING
        if (
          response.data.error &&
          Object.keys(response.data.error).length &&
          !shouldSkipErrorToast
        ) {
          showErrorToast(response.data.error[0].detail, { autoClose: 3000 });
        }

        // WARNING TOAST HANDLING
        if (response.data.warning && !shouldSkipErrorToast) {
          showWarningToast(response.data.warning, { autoClose: 3000 });
        }
      } catch (e) {
        if (e?.response?.status === 401) {
          removeCookie('token', baseDomain);
          localStorage.removeItem('expires_Time');
          localStorage.removeItem('finish_stepper');
          setToken('');

          // After the reload, redirect to the login page
          window.location.href = '/login';
        }

        // ERROR HANDLING - Only show toasts if not skipping for this endpoint
        if (
          !e?.response?.data.message &&
          !e?.response?.data.detail &&
          !e?.response?.data.error &&
          e?.response?.status === 422 &&
          !shouldSkipErrorToast
        ) {
          showErrorToast('invalid response from server');
        }
        if (e?.response?.data.message && !shouldSkipErrorToast) {
          showErrorToast(e.response.data.message);
        }
        if (e?.response?.data.detail && !shouldSkipErrorToast) {
          showErrorToast(e.response.data.detail);
        }
        if (e?.response?.data.error && !shouldSkipErrorToast) {
          for (let i in e.response.data.error) {
            for (let message in e.response.data.error[i]) {
              showErrorToast(e.response.data.error[i][message]);
            }
          }
        }

        return e;
      }

      return response;
    } else {
      let url = apiInfo.url
        .replace('{param}', queryParam)
        .replace('{param2}', queryParam2);
      let response;
      try {
        response = await axios({
          url: url,
          method: apiInfo.method,
          params: {
            ...params,
            ...apiInfo.params,
          },
          data: {
            ...data,
            ...apiInfo.data,
          },
          responseType: responseType,
          timeout: 100000,
          headers: {
            ...defaultHeaders,
            ...apiInfo.headers,
            ...headers,
          },
        });
        if (response.status === 201) {
          let request_id = response.data.data.request_id;
          var used_credit = response.data.usage.credits;
          response = await api.requestAgane(
            name,
            data,
            params,
            headers,
            queryParam,
            queryParam2,
            responseType,
            excel,
            apiInfo,
            url,
            request_id,
            used_credit
          );
        }

        // SUCCESS TOAST HANDLING
        if (response.data.message && !shouldSkipSuccessToast) {
          showSuccessToast(response.data.message);
        }

        // ERROR TOAST HANDLING
        if (
          response.data.error &&
          Object.keys(response.data.error).length &&
          !shouldSkipErrorToast
        ) {
          showSuccessToast(response.data.error[0].detail, { autoClose: 3000 });
        }

        // WARNING TOAST HANDLING
        if (response.data.warning && !shouldSkipErrorToast) {
          showWarningToast(response.data.warning, { autoClose: 3000 });
        }
      } catch (e) {
        if (e?.response?.status === 401) {
          removeCookie('token', baseDomain);
          localStorage.removeItem('expires_Time');
          localStorage.removeItem('finish_stepper');
          setToken('');

          // After the reload, redirect to the login page
          window.location.href = '/login';
        }

        // ERROR HANDLING - Only show toasts if not skipping for this endpoint
        if (
          !e?.response?.data.message &&
          !e?.response?.data.detail &&
          !e?.response?.data.error &&
          e?.response?.status === 422 &&
          !shouldSkipErrorToast
        ) {
          showErrorToast('check your inputs');
        }
        if (e?.response?.data.message && !shouldSkipErrorToast) {
          showErrorToast(e.response.data.message);
        }
        if (e?.response?.data.detail && !shouldSkipErrorToast) {
          showErrorToast(e.response.data.detail);
        }
        if (e?.response?.data.error && !shouldSkipErrorToast) {
          for (let i in e.response.data.error) {
            for (let message in e.response.data.error[i]) {
              showErrorToast(e.response.data.error[i][message]);
            }
          }
        }

        return e;
      }

      return response;
    }
  },

  call: async ({
    name,
    params,
    data,
    headers,
    queryParam,
    queryParam2,
    responseType,
    excel,
  }) => {
    return await api.request(
      name,
      data,
      params,
      headers,
      queryParam,
      queryParam2,
      responseType,
      excel
    );
  },

  requestAgane: async (
    name,
    data,
    params,
    headers,
    queryParam,
    queryParam2,
    responseType,
    excel,
    apiInfo,
    url,
    requestId,
    used_credit
  ) => {
    const token = config.token();
    axios.defaults.baseURL =
      apiInfo.service === 'base' ? config.baseUrl : config.servicesUrl;

    // Default headers
    const defaultHeaders = {
      'Content-Type': 'application/json',
    };
    defaultHeaders['authorization'] = `Bearer ${token}`;
    let responseAgane;
    responseAgane = await axios({
      url: url,
      method: apiInfo.method,
      params: {
        ...params,
        ...apiInfo.params,
      },
      data: {
        ...data,
        ...apiInfo.data,
        request_id: requestId,
      },
      responseType: responseType,
      timeout: 100000,
      headers: {
        ...defaultHeaders,
        ...apiInfo.headers,
        ...headers,
      },
    });
    let used = used_credit + responseAgane.data.usage.credits;
    if (responseAgane.status === 201) {
      await timeout(3000);
      return await api.requestAgane(
        name,
        data,
        params,
        headers,
        queryParam,
        queryParam2,
        responseType,
        excel,
        apiInfo,
        url,
        requestId,
        used
      );
    } else {
      responseAgane.data.usage.credits = used;
      return responseAgane;
    }
  },
};
export default api;
